import { NzSafeAny } from 'ng-zorro-antd/core/types';
import { IMPageResult } from './typing';
const searchColor = 'rgb(255, 0, 0)';
const searchFillColor = 'rgba(255, 0, 0, 0.4)';

export function getCount(trees: IMPageResult[]): number {
  let count = 0;
  if (!trees) {
    return 0;
  }
  Array.from(trees, (tree: IMPageResult) => {
    if (!tree.children) {
      count++;
    }
    if (tree.children) {
      count += getCount(tree.children);
    }
  });
  return count;
}

export function getStyle(): { normalStyle: object; hoverStyle: object; selectedStyle: object; activeStyle: object } {
  return {
    normalStyle: { stroke: searchColor, fill: 'transparent' },
    hoverStyle: { fill: 'transparent' },
    selectedStyle: { fill: searchFillColor, stroke: searchColor, strokeWidth: '1' },
    activeStyle: { fill: searchFillColor, stroke: searchColor, strokeWidth: '1' }
  };
}

export function getWholeKeys(trees: IMPageResult[]): NzSafeAny {
  let expand: string[] = [];
  if (!trees) {
    return [];
  }
  Array.from(trees, (tree: IMPageResult) => {
    if (tree.children) {
      expand.push(tree.name!.toString());
      expand = expand.concat(getWholeKeys(tree.children));
    }
    return '';
  });
  return expand;
}
